export function GifOverlay({gif}: {gif: api.Post}, context: jsx.AppGlobals) {
    const gettextSub = context.gtService.gettextSub;
    if (gif.unprocessed) {
        return <div className="unprocessed-overlay">
            <span>{
                // Translators: This text is displayed on a greyed out overlay
                // Translators: over images that are in the process of uploading
                // Translators: to our server. It is removed once uploading is
                // Translators: complete.
                gettextSub('Processing Upload…')
            }</span>
        </div>;
    }
    if (gif.policy_status === 'PENDING_INITIAL_REVIEW') {
        return <div className="unprocessed-overlay">
            <span>{gettextSub('Content Pending Review')}</span>
        </div>;
    }
    return null;
}
